import React from 'react';

import styled, { css } from 'styled-components';

import CloseIcon from '~/icons/components/CloseIcon';
import {
  ReviewsDrawer as BaseReviewsDrawer,
  useId,
  Picture,
  useReviewsDrawer,
} from '~/techstyle-shared/react-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const Title = styled.p`
  font-weight: 700;
  margin-right: 8px;
`;

const drawerContentStyle = css`
  display: flex;
  flex: 1;
  align-items: center;
`;

const headerStyle = css`
  flex-grow: unset;
  flex-shrink: unset;
`;

export default function ReviewsPhotoDrawer() {
  const { isPhotoDrawerOpen, closePhotoDrawer, reviewPhoto } =
    useReviewsDrawer();
  const headerId = useId();

  const Header = (
    <Container>
      <Title id={headerId}>{reviewPhoto.reviewerName}</Title>
    </Container>
  );

  return (
    <BaseReviewsDrawer
      isOpen={isPhotoDrawerOpen}
      onExit={closePhotoDrawer}
      titleId={headerId}
      closeIcon={<CloseIcon />}
      header={Header}
      drawerContentStyle={drawerContentStyle}
      headerStyle={headerStyle}
    >
      {reviewPhoto.photo && (
        <Picture
          sources={reviewPhoto.photo}
          breakpoints={[{ minWidth: 0, pictureWidth: '100%' }]}
        />
      )}
    </BaseReviewsDrawer>
  );
}
